// Ligações para o WhatsApp do EKKO (número do painel → Contacto, só algarismos)
import { ekkoText } from "@/lib/ekkoDefaults";

export function whatsappNumber(content) {
  return ekkoText(content, "whatsapp_number").replace(/\D/g, "");
}

export function whatsappLink(content, message) {
  return `https://wa.me/${whatsappNumber(content)}?text=${encodeURIComponent(message)}`;
}

// Só ligações seguras saem para a página (http, https, mailto, tel e caminhos internos)
export function safeUrl(url, fallback = "") {
  return /^(https?:|mailto:|tel:|\/|#)/i.test(url || "") ? url : fallback;
}
